/**
 * batch-67 meldingen-ontvangers (FO-500 §C7) - de kant-en-klare "Waarom"-zin.
 *
 * `beschrijfOntvangerBron` (notificatie-bron.ts) is bewust een bladmodule zonder
 * imports. Deze module vult de labels in (doelgroep en postvak-functie), zodat de
 * portal, de backoffice, de Afleveringen-tab en het beheer-signaal dezelfde zin
 * tonen met dezelfde namen.
 */
import { INBOX_FUNCTIE_LABELS } from './postvak-in'
import { resolverLabel } from './notification-rules'
import { resolverSoort } from './notificatie-resolver-soort'
import {
  beschrijfOntvangerBron,
  type NotificatieOntvangerBronDTO,
  type OntvangerBronPerspectief,
} from './notificatie-bron'

const FUNCTIE_LABELS: Readonly<Record<string, string>> = INBOX_FUNCTIE_LABELS

/** De zin achter "Waarom: " voor een melding met een spoor. */
export function waaromZin(
  bron: NotificatieOntvangerBronDTO,
  perspectief: OntvangerBronPerspectief = 'ontvanger',
): string {
  return beschrijfOntvangerBron(bron, {
    perspectief,
    resolverLabel: bron.resolver ? resolverLabel(bron.resolver) : null,
    doelgroepSoort: resolverSoort(bron.resolver),
    functieLabel: (functie) => FUNCTIE_LABELS[functie] ?? functie,
  })
}
